import InfoIcon from '@mui/icons-material/Info';
import {Fade, IconButton, Tooltip, Typography} from "@mui/material";
import {blue} from "@mui/material/colors";
import {resolveCustomerServices} from "@/services/services";
import Utils from "@/components/Shared/Utils";
import {DataGridSimpleStyled, GridColDef} from "@/components/Shared/DataGridSimple";
import {NavLink} from "react-router-dom";
import {resolveTeamPermissions} from "@/services/team";
import {useMemo} from "react";
import {selfManagedServices} from "@/features/Dashboard/Utils/MainRecentServices";
import UICard from "@/components/Shared/Utils/UICard";

export default function ServiceDashboard() {
    const {data: permissions} = resolveTeamPermissions();

    const {data} = resolveCustomerServices();
    const services = useMemo(() => selfManagedServices(data?.data?.services || []), [data]);

    const columns: GridColDef[] = [
        {
            field: 'id',
            headerName: 'ID',
            width: 100,
            editable: false,
            filterable: false,
            renderCell: ({row: service, value}) => {
                const granted = service.owned || permissions?.includes(`service:${service.service_id}:show`)

                return (
                    <>
                        {granted ? (
                            <Typography fontSize={13} sx={{my: 'auto', color: blue[900], "&:hover": {color: blue[900]}}}
                                        component={NavLink} to={{
                                pathname: `/services/${service.service_uuid}`
                            }}>
                                {value}
                            </Typography>
                        ) : (
                            <Typography fontSize={13} sx={{my: 'auto'}}>{value}</Typography>
                        )}
                    </>
                )
            }
        },
        {
            field: 'service_name',
            headerName: 'Service Name',
            width: 250,
            editable: false,
            filterable: false,
            renderCell: ({row}) => <>
                <Typography fontSize={13}>{row.service_name}</Typography>
                {row.type === 'shared' && (
                    <Tooltip
                        title="This resource is being shared from your teammate. As a shared resource, your control is restricted and relies on your teammate's configuration."
                        placement="bottom" arrow TransitionComponent={Fade} TransitionProps={{timeout: 0}}>
                        <IconButton>
                            <InfoIcon sx={{fontSize: 16}}/>
                        </IconButton>
                    </Tooltip>
                )}
            </>
        },
        {
            field: 'service_type',
            headerName: 'Type',
            width: 150,
            editable: false,
            filterable: false
        },
        {
            field: 'tenant',
            headerName: 'Org.',
            width: 200,
            editable: false,
            filterable: false
        }
    ]

    return (
        <>
            <Utils.LayoutUtils.MainContainer fullWidth>
                <Utils.LayoutUtils.MainBreadcrumbs>
                    <Typography fontSize={14}>Services</Typography>
                </Utils.LayoutUtils.MainBreadcrumbs>
                <Utils.LayoutUtils.MainWrapper>
                    <UICard>
                        <DataGridSimpleStyled rows={services} columns={columns}/>
                    </UICard>
                </Utils.LayoutUtils.MainWrapper>
            </Utils.LayoutUtils.MainContainer>
        </>
    )
}